import Component from '@bythepixel/component-loader';
import SectionTabs from '@Core/components/sectionTabs';

export default class DepartmentTabs extends Component {
  static selector = '[data-comp-department-tabs]';

  constructor(containerEl) {
    super(containerEl);

    /* eslint-disable no-new */
    new SectionTabs(containerEl);
  }
}
